


import { useState } from 'react';
import { useAppStore } from '@/modules/core/appstore/services/store';
import { ListSkeleton } from '@/components/base/Skeleton';

export default function TrialModal() {
  const { showTrialModal, setShowTrialModal, selectedApp, startTrial } = useAppStore();
  const [isProcessing, setIsProcessing] = useState(false);

  if (!showTrialModal || !selectedApp) return null;

  const handleStartTrial = async () => {
    setIsProcessing(true);
    
    // Simulate trial setup
    setTimeout(() => {
      startTrial(selectedApp.id);
      setIsProcessing(false);
    }, 1500);
  };

  const handleClose = () => {
    if (!isProcessing) {
      setShowTrialModal(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-900">Start Free Trial</h2>
            {!isProcessing && (
              <button
                onClick={handleClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            )}
          </div>
        </div>

        <div className="p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-lg overflow-hidden">
              <img
                src={selectedApp.coverImage}
                alt={selectedApp.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">{selectedApp.name}</h3>
              <p className="text-gray-600 text-sm">{selectedApp.category}</p>
            </div>
          </div>

          <div className="bg-purple-50 rounded-lg p-4 mb-6 border border-purple-100">
            <div className="flex items-center justify-center mb-3">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-time-line text-2xl text-purple-600"></i>
              </div>
            </div>
            <div className="text-center">
              <h4 className="font-semibold text-gray-900 mb-1">30-Day Free Trial</h4>
              <p className="text-gray-600 text-sm">Full access to all premium features</p>
            </div>
          </div>

          <div className="mb-6">
            <h4 className="font-medium text-gray-900 mb-2">Trial includes:</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Full access to all features
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                No credit card required
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Email support included
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Cancel anytime before trial ends
              </li>
            </ul>
          </div>

          <div className="bg-yellow-50 rounded-lg p-3 mb-6 border border-yellow-200">
            <div className="flex items-start">
              <i className="ri-information-line text-yellow-600 mr-2 mt-0.5"></i>
              <div className="text-sm">
                <p className="text-yellow-800">
                  Your trial will automatically expire after 30 days. You can upgrade to a paid plan anytime during the trial period.
                </p>
              </div>
            </div>
          </div>

          {isProcessing ? (
            <ListSkeleton />
          ) : (
            <div className="flex gap-3">
              <button
                onClick={handleClose}
                className="flex-1 px-6 py-3 border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium whitespace-nowrap"
              >
                Cancel
              </button>
              <button
                onClick={handleStartTrial}
                className="flex-1 px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium whitespace-nowrap flex items-center justify-center"
              >
                <i className="ri-play-line mr-2"></i>
                Start Trial
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
